import { useState } from 'react';
import styled from 'styled-components';

import CLOSE from '../../../../assets/imgs/icon/close.svg';
import { Button } from '../../../../GlobalComponents/Button';
import Flex from '../../../../GlobalComponents/Flex';
import { ComboContainer } from '../../../../GlobalComponents/Form';
import IconButton from '../../../../GlobalComponents/IconButton';
import { Input } from '../../../../GlobalComponents/Input';
import { Title } from '../../../../GlobalComponents/Title';

const CustomChip = ({
	cardValue,
	onAmountChange,
	onToggleCustomBal
}: ICustomChip): JSX.Element => {
	const [amount, setAmount] = useState<string>(cardValue);
	const [error, setError] = useState<string>();

	const onHandlerAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		e.preventDefault();
		setAmount(e.target.value);
	};

	const onHandleToggle = () => {
		if (Number(amount) >= 0.5) {
			// Stripe minimum charge is 50 cents
			onAmountChange(Number(amount));
			onToggleCustomBal();
		} else {
			setError('Please enter an amount over $0.50.');
		}
	};

	return (
		<>
			<Title>
				<Flex
					$flexDirection="row"
					$width="100%"
					$alignItems="center"
					$placeContent="center space-between"
				>
					Enter a custom amount
					<IconButton
						url={CLOSE}
						alt="X"
						onClick={onToggleCustomBal}
					/>
				</Flex>
			</Title>

			<ComboContainer>
				<Input
					name="custom_amount"
					label=""
					type="number"
					inputmode="number"
					pattern="[0-9]*"
					min={1}
					value={amount}
					onChange={e => onHandlerAmountChange(e)}
					placeholder="Custom Amount"
				/>

				<Button onClick={onHandleToggle} $buttonSize={'small'}>
					ADD
				</Button>
			</ComboContainer>
			{error && <ErrorDiv>{error}</ErrorDiv>}
		</>
	);
};

export default CustomChip;

interface ICustomChip {
	cardValue: string;
	onAmountChange: (amount: number) => void;
	onToggleCustomBal: () => void;
}

const ErrorDiv = styled.div`
	margin-top: 8px;
	color: #db2828 !important;
	font-weight: bold;
	font-size: 90%;
	line-height: 125%;
	margin-bottom: 0;
`;
